<div role="tab" [attr.aria-expanded]="nzActive" class="ant-collapse-header" (click)="clickHeader()">
  <ng-container *ngIf="nzShowArrow">
    <ng-container *nzStringTemplateOutlet="nzExpandedIcon; let expandedIcon">
      <ui-icon uiTheme="outline" [uiType]="expandedIcon || 'right'" class="ant-collapse-arrow" [uiRotate]="nzActive ? 90 : 0"></ui-icon>
    </ng-container>
  </ng-container>
  <ng-container *nzStringTemplateOutlet="nzHeader">{{ nzHeader }}</ng-container>
  <div class="ant-collapse-extra" *ngIf="nzExtra">
    <ng-container *nzStringTemplateOutlet="nzExtra">{{ nzExtra }}</ng-container>
  </div>
</div>
<div class="ant-collapse-content" [class.ant-collapse-content-active]="nzActive">
  <div class="ant-collapse-content-box">
    <ng-content></ng-content>
  </div>
</div>
